import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListRegionalActions } from "store/ducks/settings/regional";

export function* listRegionalRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/regional?${queryString}`);
    const comboOptions = data.map((el: any) => ({
      value: el.id,
      label: `${el.code_regional} - ${el.name}`,
    }));

    yield put(ListRegionalActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListRegionalActions.failure(errorMessage));
  }
}
